const registrationInformation = {
  AT: { registrationId: '123456' },
  AU: { registrationId: '123456789' },
  BE: { registrationId: '1234567890' },
  CA: { registrationId: '123456789' },
  DE: { registrationId: 'HRA 123', organizationRegistrationAuthority: 'Aachen' },
  ES: { registrationId: 'B12345678' },
  FI: { registrationId: '1234567-8' },
  FR: { registrationId: '123456789' },
  GB: { registrationId: 'S1234567' },
  IT: { registrationId: '62874802987' },
  KI: { registrationId: '123456789' },
  NL: { registrationId: '12357893' },
  NO: { registrationId: '123456789' },
  PL: { registrationId: '1231231239' },
  PT: { registrationId: '123123123' },
  SE: { registrationId: '123456-1234' },
  US: { registrationId: '111-11-1111' },
  OTHER: { registrationId: '62874802' },
};

const companyNotRegistered = {
  registered: false,
};

const partialRegistrationInformation = {
  registered: null,
  registrationId: null,
};

export function companyRegistrationStepConfig({ country }) {
  return {
    registrationInformation: {
      value: {
        registered: true,
        ...(registrationInformation[country] || registrationInformation.OTHER),
      },
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    companyNotRegistered: {
      value: companyNotRegistered,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partialRegistrationInformation: {
      value: partialRegistrationInformation,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
  };
}
